import { render, staticRenderFns } from "./popupCarrello.vue?vue&type=template&id=ff70b88a&"
import script from "./popupCarrello.vue.ts?vue&type=script&lang=ts&"
export * from "./popupCarrello.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports